const ADVERTISER_ID_LOCALSTORAGE_KEY = 'adv-account-selection-account-id';
const SEEK_ID_LOCALSTORAGE_KEY = 'adv-account-selection-seek-id';
const BILLING_ID_LOCALSTORAGE_KEY = 'adv-account-selection-billing-id';

export const setAdvertiserContext = (context: {
  seekId: string;
  advertiserId: string;
  billingId: string | null;
}) => {
  localStorage.setItem(ADVERTISER_ID_LOCALSTORAGE_KEY, context.advertiserId);
  localStorage.setItem(SEEK_ID_LOCALSTORAGE_KEY, context.seekId);
  if (context.billingId) {
    localStorage.setItem(BILLING_ID_LOCALSTORAGE_KEY, context.billingId);
  }
};

export const clearAdvertiserContext = () => {
  localStorage.removeItem(ADVERTISER_ID_LOCALSTORAGE_KEY);
  localStorage.removeItem(SEEK_ID_LOCALSTORAGE_KEY);
  localStorage.removeItem(BILLING_ID_LOCALSTORAGE_KEY);
};
